import React, { useEffect, useState } from "react";
import "../../_css/CreateNotification.css";
import { notifyError, notifySuccess } from "../../utils/helper";
import { sendNotification } from "../../requests";
import { startLoader } from "../../_store/reducers/loaderReducer";
import { stopLoader } from "../../_store/reducers/loaderReducer";
import { useDispatch } from "react-redux";
import { isValidEmail } from "../../utils/helper";

const CreateNotification = ({ fn }) => {
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [emailChecked, setEmailChecked] = useState(false);
  const [pushChecked, setPushChecked] = useState(false);
  const [users, setUsers] = useState([]);
  const [allChecked, setAllChecked] = useState(false);

  const handleSubmit = async () => {
    if(!validate()){
      return;
    }
    dispatch(startLoader());

    let type = 1;
    let both = false;

    
    if(pushChecked){
      type = 1;
    }
    if(emailChecked){
      type = 2;
    }

    if(emailChecked && pushChecked){
      type = 1;
      both = true;
    }

    try {
      const response = await sendNotification({
        title,
        message,
        users,
        type,
        both,
        user_group: 1,
        all: allChecked,
      });
      if(response.status < 400){
        notifySuccess(response?.data?.message || "Notification sent successfully");
        fn();
      }
    } catch (error) {
      notifyError(error?.response?.data?.error || "Something went wrong");
    } finally {
      dispatch(stopLoader());
    }
    
  };

  const validate = () =>{
    if(!title){
      notifyError("Please enter a title");
      return false;
    }
    if(!message){
      notifyError("Please enter a message");
      return false;
    }
  
    if(!emailChecked && !pushChecked){
      notifyError("Please select at least one notification type");
      return false;
    }

    if(!allChecked && users.length === 0){
      notifyError("Please add users or select 'Send notification to all teachers'");
      return false;
    }
    return true;  
  }

  const handleEmailChange = (value) => {
    setEmail(value);
  }

  const handleAddUser = () => {
    if(allChecked){
      setEmail("");
      notifyError("Please uncheck the 'Send notification to all teachers' checkbox");
      return;
    }

    if(!email){
      notifyError("Please enter an email address");
      return;
    }
    if(!isValidEmail(email)){
      notifyError("Please enter a valid email address");
      return;
    }

    if(email && !users.includes(email)){
      setUsers([...users, email]);
      setEmail("");
    } else if(users.includes(email)){
      notifyError("This email is already added");
    }
  }

  const handleRemoveUser = (user) => {
    setUsers(users.filter((u) => u != user));
  }

  useEffect(() => {
    if(allChecked){
      setUsers([]);
      setEmail("");
   
    }
  }, [allChecked]);

  return (
    <div className="n-c-popup-overlay">
      <div className="n-c-container">
        <div className="add-teacher-head">
          <div> Create Notification </div>
          <img
            style={{ cursor: "pointer" }}
            onClick={() => fn()}
            src="/close.svg"
          />
        </div>
        <div className="add-teacher-input-field" style={{ width: "437px" }}>
          <label className="add-teacher-label">Title</label>
          <input
            className="add-teacher-input"
            style={{ backgroundColor: "#F3F4F6" }}
            placeholder="Title"
            name="name"
            value={title}
            onChange={(e) => setTitle(e.target.value)}

          />
          
        </div>

        <div className="add-teacher-input-field" style={{ width: "437px" }}>
          <label className="add-teacher-label">Description</label>
          <textarea
            className="add-teacher-input"
            style={{ backgroundColor: "#F3F4F6", resize: "none" }}
            placeholder="Message"
            name="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={5}
          />
        </div>

        <div className="add-teacher-input-field" style={{ width: "437px" }}>
          <label className="add-teacher-label">User</label>
          <input
            className="add-teacher-input"
            placeholder="example@domain.com"
            name="email"
            value={email}
            onChange={(e) => handleEmailChange(e.target.value)}
          />
          <button className="my-btn" style={{ width: "fit-content", marginTop:'12px', padding:'4px 12px' }} type="button" onClick={handleAddUser}>Add</button>
        </div>

        <div className="add-teacher-input-field" style={{ width: "437px"}}>
          <label className="add-teacher-label">Users</label>
          <div className="selected-users-container">
           {users.map((user, index) => (
            <div key={index} className="selected-user-item">
              <span className="selected-user-email">{user}</span>
              <button className="remove-user-btn" type="button" onClick={() => handleRemoveUser(user)}>
                <img src="/close.svg" alt="Remove" />
              </button>
            </div>
           ))}
           
          </div>
        </div>

        
{/* Send email to all users */}
          <div
          className="di-flex"
          style={{ width: "437px", justifyContent: "start", marginTop:'12px', gap:'12px' }}
        >
          <div>
            <input className="n-c-checkbox" type="checkbox" name="All" id="All" checked={allChecked} onChange={(e) => setAllChecked(e.target.checked)} />
            <label htmlFor="All">Send notification to all teachers</label>
          </div>

         
        </div>


        <div
          className="di-flex"
          style={{ width: "437px", justifyContent: "start", marginTop:'12px', gap:'12px' }}
        >
          <div>
            <input className="n-c-checkbox" type="checkbox" name="email" id="email" checked={emailChecked} onChange={(e) => setEmailChecked(e.target.checked)} />
            <label htmlFor="email">Email</label>
          </div>

          <div>
            <input className="n-c-checkbox" type="checkbox" name="push" id="push" checked={pushChecked} onChange={(e) => setPushChecked(e.target.checked)} />
            <label htmlFor="push">Push</label>
          </div>
        </div>



        <div className="add-teacher-submit">
              { <button onClick={handleSubmit} className="add-teacher-submit-btn">
               Send
            </button>}
          </div>
      </div>
    </div>
  );
};

export default CreateNotification;
